/**
 * Picks v2 or v1 of the Challenge edit page based on the redesign flag.
 */
import React from 'react';
import { useRedesignFlag } from '../../../utils/redesignFlag';
import ChallengeAddEditPage   from './ChallengeAddEditPage';
import ChallengeAddEditPageV2 from './ChallengeAddEditPageV2';

export default function ChallengeAddEditPageSwitch(props) {
  const [v2] = useRedesignFlag();
  const Component = v2 ? ChallengeAddEditPageV2 : ChallengeAddEditPage;
  return <Component {...props} />;
}
